import { inject } from '@angular/core';
import { HttpRequest, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError, catchError, switchMap } from 'rxjs';
import { AuthService } from '@app/core/services/auth.service';

export const AuthTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const newRequest = cloneRequestWithAuthToken(req, authService);

  return next(newRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error && error.status === 401 && !req.url.includes('/auth/refresh')) {
        return authService.refreshToken().pipe(
          catchError(() => {
            return authService.logout();
          }),
          switchMap(() => next(cloneRequestWithAuthToken(req, authService)))
        );
      } else {
        return throwError(() => error);
      }
    })
  );
};

function cloneRequestWithAuthToken(req: HttpRequest<unknown>, authService: AuthService) {
  const authToken = authService.getAuthToken();

  return req.clone({
    setHeaders: authToken ? { Authorization: `Bearer ${authToken}` } : {}
  });
}
